import { TRANSFER_TYPE } from '../../types';
import { TRANSFER_STATUS_VALUE } from '@shared/types/enums/transfer-status.enum';

import { DEPARTMENT_CODE_NOT_CONFIGURED } from './transfer-constants';
import { I18n } from '@app/i18n/strings-keys';

export const DISPLAY_EVENT_TYPES = [
  TRANSFER_TYPE.PRE_EVENT_TRANSFER,
  TRANSFER_TYPE.DURING_EVENT_TRANSFER,
];

export const DEPARTMENT_SORT_LIST = [
  'Concessions',
  'Premium',
  'Suites',
  'Other',
  DEPARTMENT_CODE_NOT_CONFIGURED,
];

export const DEPARTMENT_I18N_CODE_MAP = {
  Concessions: I18n.Common.Concessions,
  Premium: I18n.Common.Premium,
  Suites: I18n.Common.Suites,
  Other: I18n.Common.Other,
  [DEPARTMENT_CODE_NOT_CONFIGURED]: I18n.Common.NotConfigured,
};

export const TRANSFER_FINAL_STATUS: TRANSFER_STATUS_VALUE[] = [
  TRANSFER_STATUS_VALUE.Canceled,
  TRANSFER_STATUS_VALUE.Completed,
  TRANSFER_STATUS_VALUE.Void,
  TRANSFER_STATUS_VALUE.Rejected,
];

export const TRANSFER_NOT_FINAL_STATUS: TRANSFER_STATUS_VALUE[] = [
  TRANSFER_STATUS_VALUE.New,
  TRANSFER_STATUS_VALUE.Open,
  TRANSFER_STATUS_VALUE.Pending,
  TRANSFER_STATUS_VALUE.Null,
];

export const TRANSFER_UNSAVED_STATUS: TRANSFER_STATUS_VALUE[] = [
  TRANSFER_STATUS_VALUE.Null,
  TRANSFER_STATUS_VALUE.New,
];

export const TRANSFER_SAVED_STATUS: TRANSFER_STATUS_VALUE[] = [
  TRANSFER_STATUS_VALUE.Open,
  TRANSFER_STATUS_VALUE.Pending,
  TRANSFER_STATUS_VALUE.Canceled,
  TRANSFER_STATUS_VALUE.Completed,
  TRANSFER_STATUS_VALUE.Void,
  TRANSFER_STATUS_VALUE.Rejected,
];

export const TRANSFER_OPEN_PENDING_STATUS: TRANSFER_STATUS_VALUE[] = [
  TRANSFER_STATUS_VALUE.Open,
  TRANSFER_STATUS_VALUE.Pending,
];
